"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LunaIconSpriteContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _depCheck = _interopRequireDefault(require("../../dep-check"));

var _lunaIcons = require("@uitk/luna-icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LunaIconSpriteContext = _react["default"].createContext(false);

exports.LunaIconSpriteContext = LunaIconSpriteContext;

var LunaIconSpriteProvider = function LunaIconSpriteProvider(_ref) {
  var _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === void 0 ? '' : _ref$namespace,
      children = _ref.children;
  (0, _depCheck["default"])([]);
  return _react["default"].createElement(LunaIconSpriteContext.Provider, {
    value: namespace
  }, _react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: (0, _lunaIcons.lunaStringifySprite)(namespace)
    }
  }), children);
};

LunaIconSpriteProvider.displayName = 'LunaIconSpriteProvider';
LunaIconSpriteProvider.propTypes = {
  namespace: _propTypes["default"].string
};
LunaIconSpriteProvider.defaultProps = {
  namespace: ''
};
var _default = LunaIconSpriteProvider;
exports["default"] = _default;
